import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState, useCallback } from 'react';
import cx from 'classnames';
import { Icon } from 'panamera-react-ui';
import ReactMarkdown from 'react-markdown';
import { UNKNOWN } from "../../Constants/locations";
import { withComponentDependency } from "./../../ComponentDependency/withComponentDependency";
import { compose } from 'redux';
var css = {
  "accordian": "oalp-1Ejof",
  "accordian__header": "oalp-1I9Ay",
  "headerText": "oalp-14jRy",
  "isOpen": "oalp-39BLW",
  "accordian__content": "oalp-3wW1Z"
};
import { withRouter } from "../../Helpers/withRouter";
import TrackingInfoManager from "../../Utils/TrackingInfoManager";
export var Accordian = function Accordian(_ref) {
  var headerText = _ref.headerText,
    content = _ref.content,
    _ref$isOpenByDefault = _ref.isOpenByDefault,
    isOpenByDefault = _ref$isOpenByDefault === void 0 ? false : _ref$isOpenByDefault,
    track = _ref.track,
    browsingMode = _ref.browsingMode,
    locationId = _ref.locationId,
    origin = _ref.origin,
    metadata = _ref.metadata,
    _ref$qnAsStyle = _ref.qnAsStyle,
    qnAsStyle = _ref$qnAsStyle === void 0 ? {} : _ref$qnAsStyle;
  var _useState = useState(isOpenByDefault),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setOpenStatus = _useState2[1];
  var onHeaderClick = useCallback(function () {
    setOpenStatus(function (currOpenStatus) {
      return !currOpenStatus;
    });
    if (metadata && metadata.trackingInfo && metadata.trackingInfo.clickEvent && metadata.trackingInfo.clickEvent.name) {
      var trackingInfo = TrackingInfoManager.getTrackingInfo({
        browsing_location_id: locationId || UNKNOWN,
        browsing_mode: browsingMode,
        origin: origin,
        chosen_option: headerText
      });
      track(metadata.trackingInfo.clickEvent.name, trackingInfo);
    }
  }, [browsingMode, headerText, locationId, origin, track, metadata]);
  return /*#__PURE__*/React.createElement("div", {
    className: css.accordian
  }, /*#__PURE__*/React.createElement("a", {
    className: cx(css.accordian__header, _defineProperty({}, css.isOpen, isOpen)),
    onClick: onHeaderClick
  }, /*#__PURE__*/React.createElement("div", {
    className: css.headerText
  }, headerText), /*#__PURE__*/React.createElement(Icon, {
    icon: isOpen ? 'arrowUp' : 'arrowDown',
    size: 16
  })), /*#__PURE__*/React.createElement("div", {
    style: qnAsStyle,
    className: cx(css.accordian__content, _defineProperty({}, css.isOpen, isOpen))
  }, /*#__PURE__*/React.createElement(ReactMarkdown, {
    linkTarget: "_blank"
  }, content)));
};
export default compose(React.memo, withComponentDependency, withRouter)(Accordian);